import React, { useState } from 'react';

export default function ToggleSwitchCM({state,togglefun}) {

  const toggleSwitch = () => {
    console.log("toggle fun cal",state)
    togglefun();
  };

  return (
    <div className="flex items-center">
      <button
        type="button"
        onClick={toggleSwitch}
        className={`ml-[5px] relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
          state ? 'bg-blue-600' : 'bg-sky-100'
        }`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
            state ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
    </div>
  );
}
